/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Colleague } from '../models/Colleague';
import type { CompanyCancellationStateSchema } from '../models/CompanyCancellationStateSchema';
import type { CompanyImportDataCreateResponseSchema } from '../models/CompanyImportDataCreateResponseSchema';
import type { CompanyImportDataCreateSchema } from '../models/CompanyImportDataCreateSchema';
import type { CompanyImportDataSchema } from '../models/CompanyImportDataSchema';
import type { CompanyInsuranceSettingsCreateOrUpdateSchema } from '../models/CompanyInsuranceSettingsCreateOrUpdateSchema';
import type { CompanyInsuranceSettingsDetailSchema } from '../models/CompanyInsuranceSettingsDetailSchema';
import type { CompanyInsuranceSettingsListSchema } from '../models/CompanyInsuranceSettingsListSchema';
import type { CompanyPermissionsSchemaOverview } from '../models/CompanyPermissionsSchemaOverview';
import type { CompanyRewardProgressSchema } from '../models/CompanyRewardProgressSchema';
import type { CompanySubscriptionPeriodSchema } from '../models/CompanySubscriptionPeriodSchema';
import type { CreateColleague } from '../models/CreateColleague';
import type { MyCompany } from '../models/MyCompany';
import type { MyCompanySettings } from '../models/MyCompanySettings';
import type { PagedColleague } from '../models/PagedColleague';
import type { PagedColleagueListSchema } from '../models/PagedColleagueListSchema';
import type { PasswordSetSchema } from '../models/PasswordSetSchema';
import type { PatchMyCompanySchema } from '../models/PatchMyCompanySchema';
import type { RecurringUpdateStrategyChoices } from '../models/RecurringUpdateStrategyChoices';
import type { ReminderSmsBodyPropsSchema } from '../models/ReminderSmsBodyPropsSchema';
import type { SetRole } from '../models/SetRole';
import type { SmsCharacterLimitsSchema } from '../models/SmsCharacterLimitsSchema';
import type { TimeOffCreateSchema } from '../models/TimeOffCreateSchema';
import type { TimeOffDetailSchema } from '../models/TimeOffDetailSchema';
import type { TimeOffUpdateSchema } from '../models/TimeOffUpdateSchema';
import type { UpdateColleague } from '../models/UpdateColleague';
import type { UpdateMyCompanySettings } from '../models/UpdateMyCompanySettings';
import type { WorkingHoursCreateSchema } from '../models/WorkingHoursCreateSchema';
import type { WorkingHoursDetailSchema } from '../models/WorkingHoursDetailSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanyApi {
    /**
     * @deprecated
     * Get Company Insurance Settings
     * List my company insurance settings. <br>Required permission: list_my_company_insurance_settings
     * @returns CompanyInsuranceSettingsDetailSchema OK
     * @throws ApiError
     */
    public static companiesGetCompanyInsuranceSettingsGet(): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/insurance_settings/',
        });
    }
    /**
     * @deprecated
     * Create Or Update Company Insurance Settings
     * Create or update my company insurance settings. <br>Required permission: edit_company_details
     * @returns CompanyInsuranceSettingsDetailSchema OK
     * @throws ApiError
     */
    public static companiesCreateOrUpdateCompanyInsuranceSettingsPost({
        requestBody,
    }: {
        requestBody: CompanyInsuranceSettingsCreateOrUpdateSchema,
    }): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/insurance_settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @deprecated
     * Get Company Insurance Settings List
     * List all company insurance settings (all IČZ). <br>Required permission: list_my_company_insurance_settings
     * @returns CompanyInsuranceSettingsListSchema OK
     * @throws ApiError
     */
    public static companiesGetCompanyInsuranceSettingsListGet(): CancelablePromise<Array<CompanyInsuranceSettingsListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/insurance_settings/overview/',
        });
    }
    /**
     * Update Company Insurance Settings Cssz Tls Certificate
     * Replace the ČSSZ TLS certificate of this IČO and its password. <br>Required Permission: edit_company_details
     * @returns CompanyInsuranceSettingsDetailSchema OK
     * @throws ApiError
     */
    public static companiesUpdateCompanyInsuranceSettingsCsszTlsCertificatePost({
        companyInsuranceSettingsId,
        formData,
    }: {
        companyInsuranceSettingsId: string,
        formData: {
            file: Blob;
            password: string;
        },
    }): CancelablePromise<CompanyInsuranceSettingsDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/insurance_settings/{company_insurance_settings_id}/cssz-tls-certificate/',
            path: {
                'company_insurance_settings_id': companyInsuranceSettingsId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Add Colleague
     * Invite colleague. <br>Required permission: invite_colleagues
     * @returns Colleague Created
     * @throws ApiError
     */
    public static companiesAddColleaguePost({
        requestBody,
    }: {
        requestBody: CreateColleague,
    }): CancelablePromise<Colleague> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/colleagues/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List Colleagues
     * Get list of colleagues.<br>Required permission: list_colleagues <br>Use 'order' to sort by field (ASC created_at or DESC prepend '-' to field name) <br>Required Permission: list_colleagues
     * @returns PagedColleagueListSchema OK
     * @throws ApiError
     */
    public static companiesListColleaguesGet({
        order = '',
        limit = 100,
        offset,
    }: {
        order?: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedColleagueListSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/colleagues/',
            query: {
                'order': order,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get My Company
     * Get my company details.<br>Required permission: get_my_company
     * @returns MyCompany OK
     * @throws ApiError
     */
    public static companiesGetMyCompanyGet(): CancelablePromise<MyCompany> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/',
        });
    }
    /**
     * Patch My Company
     * Patch my company. <br>Required Permission: 'edit_company_details'
     * @returns MyCompany OK
     * @throws ApiError
     */
    public static companiesPatchMyCompanyPatch({
        requestBody,
    }: {
        requestBody: PatchMyCompanySchema,
    }): CancelablePromise<MyCompany> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/company/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get My Company Settings
     * List my company settings. <br>Required permission: list_my_company_settings
     * @returns MyCompanySettings OK
     * @throws ApiError
     */
    public static companiesGetMyCompanySettingsGet(): CancelablePromise<MyCompanySettings> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/settings/',
        });
    }
    /**
     * Update My Company Settings
     * Partial update company settings.<br>Required Permission: 'edit_company_details'
     * @returns void
     * @throws ApiError
     */
    public static companiesUpdateMyCompanySettingsPatch({
        requestBody,
    }: {
        requestBody: UpdateMyCompanySettings,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/company/settings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload My Company Terms And Conditions
     * Update company terms and conditions.<br>Required Permission: 'edit_company_details'
     * @returns void
     * @throws ApiError
     */
    public static companiesUploadMyCompanyTermsAndConditionsPost({
        formData,
    }: {
        formData: {
            file: Blob;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/settings/terms-upload',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete My Company Terms And Conditions
     * Delete company terms and conditions.<br>Required Permission: 'edit_company_details'
     * @returns void
     * @throws ApiError
     */
    public static companiesDeleteMyCompanyTermsAndConditionsPatch(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/company/settings/terms-delete',
        });
    }
    /**
     * Enable M Records
     * Enable M-Records integration for the company.<br>Required Permission: 'edit_company_details'
     * @returns void
     * @throws ApiError
     */
    public static companiesEnableMRecordsPost(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/settings/enable-m-records',
        });
    }
    /**
     * Create Company Import Data
     * @returns CompanyImportDataCreateResponseSchema Created
     * @throws ApiError
     */
    public static companiesCreateCompanyImportDataPost({
        requestBody,
    }: {
        requestBody: CompanyImportDataCreateSchema,
    }): CancelablePromise<CompanyImportDataCreateResponseSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/import-data/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Patch Companies Import Data
     * @returns CompanyImportDataSchema OK
     * @throws ApiError
     */
    public static companiesPatchCompaniesImportDataPost({
        companyImportDataId,
    }: {
        companyImportDataId: string,
    }): CancelablePromise<CompanyImportDataSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/import-data/{company_import_data_id}/confirm/',
            path: {
                'company_import_data_id': companyImportDataId,
            },
        });
    }
    /**
     * Get Colleague Suggestion
     * Get suggestion of colleagues name. Use name query param to filter colleagues by name.<br>Required permission: list_colleague_suggestions
     * @returns PagedColleague OK
     * @throws ApiError
     */
    public static companiesGetColleagueSuggestionGet({
        name,
        limit = 100,
        offset,
    }: {
        name: string,
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedColleague> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/colleagues/suggestion/',
            query: {
                'name': name,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Get My Company Permissions
     * @returns CompanyPermissionsSchemaOverview OK
     * @throws ApiError
     */
    public static companiesGetMyCompanyPermissionsGet(): CancelablePromise<Array<CompanyPermissionsSchemaOverview>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/permissions/',
        });
    }
    /**
     * Get Colleague
     * Get colleague detail. <br>Required Permission: get_colleague
     * @returns Colleague OK
     * @throws ApiError
     */
    public static companiesGetColleagueGet({
        colleagueId,
    }: {
        colleagueId: string,
    }): CancelablePromise<Colleague> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/colleagues/{colleague_id}/',
            path: {
                'colleague_id': colleagueId,
            },
        });
    }
    /**
     * Update Colleague
     * Update colleague. <br>Required Permission: 'update_colleague'
     * @returns Colleague OK
     * @throws ApiError
     */
    public static companiesUpdateColleaguePut({
        colleagueId,
        requestBody,
    }: {
        colleagueId: string,
        requestBody: UpdateColleague,
    }): CancelablePromise<Colleague> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company/colleagues/{colleague_id}/',
            path: {
                'colleague_id': colleagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deactivate Colleague
     * Deactivate colleague. <br> Required permissions: deactivate_colleague
     * @returns void
     * @throws ApiError
     */
    public static companiesDeactivateColleagueDelete({
        colleagueId,
    }: {
        colleagueId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company/colleagues/{colleague_id}/',
            path: {
                'colleague_id': colleagueId,
            },
        });
    }
    /**
     * Set Colleague Role
     * Update colleague role. <br>Required Permission: update_colleague_role
     * @returns Colleague OK
     * @throws ApiError
     */
    public static companiesSetColleagueRolePatch({
        userId,
        requestBody,
    }: {
        userId: string,
        requestBody: SetRole,
    }): CancelablePromise<Colleague> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/company/colleagues/{user_id}/role',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Colleague Working Hours
     * Create colleague working hours.<br>Required Permission: 'create_colleague_working_hours'
     * @returns WorkingHoursDetailSchema OK
     * @throws ApiError
     */
    public static companiesCreateColleagueWorkingHoursPost({
        colleagueId,
        requestBody,
    }: {
        colleagueId: string,
        requestBody: WorkingHoursCreateSchema,
    }): CancelablePromise<WorkingHoursDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/colleagues/{colleague_id}/working-hours/',
            path: {
                'colleague_id': colleagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Colleague Working Hours
     * Get colleague working hours.<br>Required Permission: 'get_colleague_working_hours'
     * @returns WorkingHoursDetailSchema OK
     * @throws ApiError
     */
    public static companiesGetColleagueWorkingHoursGet({
        colleagueId,
    }: {
        colleagueId: string,
    }): CancelablePromise<WorkingHoursDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/colleagues/{colleague_id}/working-hours/',
            path: {
                'colleague_id': colleagueId,
            },
        });
    }
    /**
     * Update Colleague Working Hours
     * Update colleague working hours.<br>Required Permission: 'update_colleague_working_hours'
     * @returns WorkingHoursDetailSchema OK
     * @throws ApiError
     */
    public static companiesUpdateColleagueWorkingHoursPut({
        colleagueId,
        requestBody,
    }: {
        colleagueId: string,
        requestBody: WorkingHoursCreateSchema,
    }): CancelablePromise<WorkingHoursDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company/colleagues/{colleague_id}/working-hours/',
            path: {
                'colleague_id': colleagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create Colleague Time Off
     * Create colleague time off.<br>Required Permission: 'create_colleague_time_off'
     * @returns TimeOffDetailSchema Created
     * @throws ApiError
     */
    public static companiesCreateColleagueTimeOffPost({
        colleagueId,
        requestBody,
    }: {
        colleagueId: string,
        requestBody: TimeOffCreateSchema,
    }): CancelablePromise<TimeOffDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/colleagues/{colleague_id}/time-off/',
            path: {
                'colleague_id': colleagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Colleague Time Off
     * Delete colleague time off.<br>Required Permission: 'delete_colleague_time_off'
     * @returns void
     * @throws ApiError
     */
    public static companiesDeleteColleagueTimeOffDelete({
        colleagueId,
        timeOffId,
        recurringUpdateStrategy,
    }: {
        colleagueId: string,
        timeOffId: string,
        recurringUpdateStrategy?: (RecurringUpdateStrategyChoices | null),
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company/colleagues/{colleague_id}/time-off/{time_off_id}/',
            path: {
                'colleague_id': colleagueId,
                'time_off_id': timeOffId,
            },
            query: {
                'recurring_update_strategy': recurringUpdateStrategy,
            },
        });
    }
    /**
     * Update Colleague Time Off
     * Update colleague time off.<br>Required Permission: 'update_colleague_time_off'
     * @returns TimeOffDetailSchema OK
     * @throws ApiError
     */
    public static companiesUpdateColleagueTimeOffPut({
        colleagueId,
        timeOffId,
        requestBody,
    }: {
        colleagueId: string,
        timeOffId: string,
        requestBody: TimeOffUpdateSchema,
    }): CancelablePromise<TimeOffDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/company/colleagues/{colleague_id}/time-off/{time_off_id}/',
            path: {
                'colleague_id': colleagueId,
                'time_off_id': timeOffId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Company Reward Progress
     * Get company reward progress.<br>Required permission: get_company_reward_progress
     * @returns CompanyRewardProgressSchema OK
     * @throws ApiError
     */
    public static companiesGetCompanyRewardProgressGet(): CancelablePromise<CompanyRewardProgressSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/company-reward-progress/',
        });
    }
    /**
     * Get Reminder Sms Body Props
     * List my company settings.
     * @returns ReminderSmsBodyPropsSchema OK
     * @throws ApiError
     */
    public static companiesGetReminderSmsBodyPropsGet(): CancelablePromise<Array<ReminderSmsBodyPropsSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/settings/reminder-sms-body-props/',
        });
    }
    /**
     * Get Sms Body Props Values
     * List sms character limits.
     * @returns SmsCharacterLimitsSchema OK
     * @throws ApiError
     */
    public static companiesGetSmsBodyPropsValuesGet(): CancelablePromise<SmsCharacterLimitsSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/settings/sms-limits/',
        });
    }
    /**
     * Upload My Company Logo
     * Upload company logo. <br>Required Permission: edit_company_details
     * @returns void
     * @throws ApiError
     */
    public static companiesUploadMyCompanyLogoPost({
        formData,
    }: {
        formData: {
            image: Blob;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/logo/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete My Company Logo
     * Delete company logo. <br>Required Permission: edit_company_details
     * @returns void
     * @throws ApiError
     */
    public static companiesDeleteMyCompanyLogoDelete(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company/logo/',
        });
    }
    /**
     * Delete My Company Signature
     * Delete company signature. <br>Required Permission: edit_company_details
     * @returns void
     * @throws ApiError
     */
    public static companiesDeleteMyCompanySignatureDelete(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company/signature/',
        });
    }
    /**
     * Upload My Company Signature
     * Upload company signature. <br>Required Permission: edit_company_details
     * @returns void
     * @throws ApiError
     */
    public static companiesUploadMyCompanySignaturePost({
        formData,
    }: {
        formData: {
            image: Blob;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/signature/',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Set Colleague Password
     * Set colleague password. <br>Required Permission: set_colleague_password
     * @returns any OK
     * @throws ApiError
     */
    public static companiesSetColleaguePasswordPost({
        userId,
        requestBody,
    }: {
        userId: string,
        requestBody: PasswordSetSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/colleagues/{user_id}/password',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Cancellation State
     * Termination state: which action is offered (cancel tariff / delete account) and to which date it applies. <br>Required permission: list_my_company_orders
     * @returns CompanyCancellationStateSchema OK
     * @throws ApiError
     */
    public static companiesGetCancellationStateGet(): CancelablePromise<CompanyCancellationStateSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/cancellation/',
        });
    }
    /**
     * Cancel Subscription
     * Cancel the tariff at the end of the currently paid period. The app stays available until that date. <br>Required permission: cancel_subscription
     * @returns CompanyCancellationStateSchema OK
     * @throws ApiError
     */
    public static companiesCancelSubscriptionPost(): CancelablePromise<CompanyCancellationStateSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/company/cancellation/',
        });
    }
    /**
     * Delete Company Account
     * Permanently delete the company and all its data. Only for companies without a paid tariff; issued invoices are kept. <br>Required permission: delete_company_account
     * @returns void
     * @throws ApiError
     */
    public static companiesDeleteCompanyAccountDelete(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/company/account/',
        });
    }
    /**
     * Get Subscription Period
     * Current tariff period (from/to), pricing type, free mode flag and next billing date.<br>Required permission: list_my_company_orders
     * @returns CompanySubscriptionPeriodSchema OK
     * @throws ApiError
     */
    public static companiesGetSubscriptionPeriodGet(): CancelablePromise<CompanySubscriptionPeriodSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/company/subscription/',
        });
    }
}
